module.exports = __webpack_public_path__ + "static/media/DSC9074.2ab3e92d.png";